
import React, { useState, useEffect, useContext } from "react";
import * as Config from "../../constants/Config";
import { useNavigate, Link } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import Footer from "../../components/dashboard/footer";
import axios from "axios";
let {lambda,appname}=window.app;
const SubscriptionPlan = () => {
    const { userData } = useContext(contentContext);
    const [image, setImg] = useState('');
    const [subscriptionsData, setSubscriptionsData] = useState([]);
    const navigate = useNavigate();
    // const handleBack = () => {
    //     navigate('/')
    // }
    let id = localStorage.getItem("clientid");
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
 useEffect(() => {
    getClientData()
     
   }, []);
   useEffect(() => {
    const handlePopState = () => {
      console.log("Browser back button clicked");
      // You can do custom navigation here
      // Example: navigate("/somewhere");
      navigate("/signin", { state: { flag: true } });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
   const getClientData = (e) => {
    // GetTimeActivity()   
    const token = localStorage.getItem("token")
    axios({
        method: 'GET',
        url: lambda + '/clientInfo?appname=' + appname+"&clientid="+id 
    })
        .then(function (response) {
            //  console.log("response", response?.data?.result?.[0]);
            if (response?.data?.result?.length > 0) {
                setSubscriptionsData(response?.data?.result?.[0]);
            }
        });
}
console.log("subcrip[tionDattatatattta",subscriptionsData)
const submitClick = (e,price) => {
    localStorage.setItem("backto","/signin")
if(subscriptionsData?.subscriptionPrice==="0" || subscriptionsData?.subscriptionPrice === 0){
navigate("/addstore")
}else{
    navigate("/payment", { state: subscriptionsData }); 
}
    
  
   // navigate('/payment?price=' + price)
}
//console.log("subscriptionsData",subscriptionsData)
    return (
        <>

            <div className="signin-wrapper get_started" id="signin-wrapper">
                <div className="card">
                    <div className="card-body">
                        <div className="get_started_block">
                            <div className="left">
                                <div className="welcome_block">
                                    <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/First-time-graphic.svg" id="signin-graphic-img" />
                                    <div className="Welcome">
                                        <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/logo-dark.png" class="logo" id="signin-logo" />
                                        <h5>Welcome Dario Bar and Lounge,</h5>
                                        <p className="excited">We’re excited to have you on board! You can effortlessly manage spots and schedule table bookings, ensuring a seamless experience for your customers<span>—no more long queues!</span></p>
                                        <p className="need_assistance">Need assistance? Our team is here to help! <br /><span>Contact {subscriptionsData?.phone}</span></p>
                                    </div>
                                </div>

                                <div className="subscription-txt">
                                    <p className="plan-txt">Your subscription Plan is <span className="Rate-Txt">{subscriptionsData?.subscription} {subscriptionsData?.subscriptionPrice ? "$" + subscriptionsData?.subscriptionPrice : 0} </span></p>
                                    {subscriptionsData?.subscriptionPayment ? (
  <p className="Payment-Status">
    {subscriptionsData?.subscriptionPayment}
    <span className="material-symbols-outlined">error</span>
  </p>
) : null}

                                    <button class="fill-btn save_continue" onClick={e=>submitClick(e,subscriptionsData?.subscriptionPrice)}>GET STARTED</button>
                                </div>

                            </div>
                            <div className="right">
                                <div className="right-wrapper">
                                    <h3 className="semi-heading">Get Started</h3>
                                    <p className="excited">Manage your store in 4 simple and easy steps.</p>

                                    <div className="navigation-section">
                                        <div className="navigation-item">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/create-store.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Create Store</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/set-store-preference.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Set Store Preference</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/manage-hours.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Manage Hours</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/final-launch.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Launch</p>
                                            </div>
                                        </div>


                                    </div>

                                    <p className="plan-txt">Let’s create a smoother booking experience together!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

        </>
    );
};

export default SubscriptionPlan;
